import React, { Component } from 'react'
const defaultImage = '../img/default-image.png';
// import zChat from 'vendor/web-sdk';
import { connect } from 'react-redux'
// import { log } from 'utils';

class GallaryCard extends Component {

    constructor(props) {
      super(props);
      this.state={
          visibleData: false
      };
      this.renderActionButtons = this.renderActionButtons.bind(this);
      this.sendMsg = this.sendMsg.bind(this);
    }

    sendMsg(msg) {


        if(msg !== 'null'){
            // var prevMsg = document.getElementById('msgWrapper').lastChild;
            // if(prevMsg.querySelector('.chat-options')){
            //     prevMsg.querySelector('.chat-options').style.display = 'none';
            // }
            if(document.getElementById('msgWrapper').lastChild){
                let prevMsg = document.getElementById('msgWrapper').lastChild;
         
               if(prevMsg.classList.contains('system-msg-container')){
                if(prevMsg.previousSibling){
                  let currNode = prevMsg.previousSibling;
        
                  while(currNode && currNode.classList.contains('system-msg-container')){
                    currNode = currNode.previousSibling;
                  }
                  if(currNode && currNode.querySelector('.chat-options')){
                    currNode.querySelector('.chat-options').style.display = 'none';
                  }
                }
               }
                if(prevMsg && prevMsg.querySelector('.chat-options')){
                    prevMsg.querySelector('.chat-options').style.display = 'none';
        
                }
              }
            this.props.dispatch({
              type: 'chat',
              detail: {
                display_name: 'BOT',
                nick: 'agent:363464957659',
                msg,
                options: [],
                timestamp: Date.now(),
                type: 'chat.msg'
              }
            });
        }
    }


    renderActionButtons(buttons) {
        if (!buttons) return;
    
        return (
            // eslint-disable-next-line no-trailing-spaces
            <div className="action-buttons">                
                {
                    buttons.map((button, i) => {
                        if(button.action.type==='LINK_ACTION'){
                            return (
                                <span className="action-btn-wrapper" data-id={i} key={i}>
                                    <a href={button.action.value ? button.action.value : ''} className="action-btn-link"  target="_blank">
                                        {button.text ? button.text : 'Action Button'}
                                    </a>
                                </span>
                            )
                        } else {
                            return (
                                <span className="action-btn-wrapper" data-id={i} key={i}>
                                    <button onClick={()=>this.sendMsg(button.action.value)} className="action-btn">
                                        {button.text ? button.text : 'Action Button'}
                                    </button>
                                </span>
                            )
                            }
                    })
                }
            </div>
        )
    }

    render() {
        let temp = this.props.message.panel.heading;
        temp=temp.split('$%!');
        let title = temp[0];
        let subtitle=''
        if(temp[1]){
            subtitle = temp[1]
        }

        let tempParagrah = this.props.message.panel.paragraph;
        let paragraph = tempParagrah;
        let floating_image;
        if(tempParagrah){
            tempParagrah = tempParagrah.split('&!@$');
            paragraph = tempParagrah[0]
            if(tempParagrah[1]){
                floating_image = tempParagrah[1]
            }
        }
        return (
            <div className="main-card-container">
                <div className="image-container">
                    <div className="main-image-container">
                        <img className="card-image" src={this.props.message.panel.image_url ? this.props.message.panel.image_url : defaultImage} alt="Gally Image"/>
                    </div>
                   {floating_image && <div className= "floating-image-container">
                        <img className="floating-image" src={floating_image} alt="Gally Image"/>
                    </div>}
                </div>
                {title && title !== 'null' && <div className="card-details-container">
                    <h4 className="card-title">
                        {title ? (title  === 'null' ? '' : title) : ''}
                    </h4>
                    {subtitle && <h6 className="card-sub-title">
                        {subtitle}
                    </h6>}
                    <p className="card-description">
                        {paragraph ? ( (paragraph  === 'null' || paragraph === 'undefined') ? '' : paragraph) : ''}
                    </p>
                </div>}
                {this.props.message.buttons ? (this.props.message.buttons === 'null' ? ''  : this.renderActionButtons(this.props.message.buttons)) : ''}
            </div>
        )
    }
}

export default connect()(GallaryCard);



// WEBPACK FOOTER //
// ./src/components/GallaryCard.js